<!-- 
  
-->
<template> 
    <div v-show="loaded" class="iframe-container" :style="[setStyleContainer]">
          <iframe
            id="iframe"
            :src="this.fonte"
            :width="this.width"
            :height="'100%'"
            :frameborder="this.frameborder"
            :scrolling="this.scrolling"
            @load="this.load"
            :style="[setStyleIframe]" >
           </iframe>
    </div>
</template>

<script>
export default {
  name: 'iframeBI',
  components: {
  },
  props:{
    fonte: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: ''
    },
    scrolling: {
      type: String,
      default: 'no'
    },
    frameborder: {
      type: String,
      default: '0'
    },
    estiloContainer: {
      type: Object,
      default: () => ({})
    },
    estiloIframe: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  mounted () {
    
  },
  created () {
    this.$store.commit('loading/startLoading');
  },
  computed: {
    setStyleContainer() {
      return (Object.keys(this.estiloContainer).length ? this.estiloContainer : { "height": this.height })
    },
    setStyleIframe() {
      return (Object.keys(this.estiloIframe).length ? this.estiloIframe : '')
    },
  },
  methods: {
		load: function(){
      if(this.fonte) {
        this.loaded = true;
        this.$store.commit('loading/endLoading');
      }
    },
    onDocumentLoad: function() {
            
    },
  } 
}


</script>

<style scoped>
 
 

.iframe-container {
  overflow: hidden;
  position: relative;
}
@media (min-width: 858px) {
  .iframe-container {
    height: calc(100vh - 165px);
  }
}

@media (min-width: 767px) and (max-width: 857px) {
  .iframe-container {
    height: calc(100vh - 190px);
  }
}

@media (min-width: 614px) and (max-width: 766px) {
  .iframe-container {
    height: calc(100vh - 165px);
  }
}

@media (min-width: 364px) and (max-width: 613px) {
  .iframe-container {
    height: calc(100vh - 200px);
  }
}
@media (max-width: 363px) {
  .iframe-container {
    height: calc(100vh - 262px);
  }
}
 
.iframe-container #iframe {
   border: 0;
   height: 100%;
   left: 0;
   position: relative;
   top: 0;
   width: 100%;
}

</style>



